require('jquery.flot')
require("../../scss/_variables.scss")
require("@rails/ujs")

import {
  drawPlot,
  plotZoom,
  validateInputs,
  updateAnswer,
} from 'packs/dogs/mixed_breed_height_calculation.js'

document.addEventListener("turbolinks:load", () => {
  window.onresize = function(event) {
    drawPlot();
  };

  $('.zoom').on('click', function (e) {
    debugger
    var to = parseFloat($(this).data('to'));
    var from = parseFloat($(this).data('from'));
    plotZoom({xaxis: {from: from, to: to}});
    $('.zoom').removeClass('active');
    $(e.target).addClass('active');
    return false;
  });

  setTimeout(function() {
    drawPlot();
    $("#placeholder").bind("plotselected", function (event, ranges) {
      plotZoom(ranges);
    });
  }, 350);

  $('#mixed-breed-puppy-height-form').on('submit', function(event) {
    if (validateInputs()) {
      return true;
    } else {
      return false;
    }
  })

  if ($('#mixed_breed_puppy_height_params').length !== 0) {
    updateAnswer();
  }

  if ($('.transient-intro').length && window.innerWidth < 576) {
    if (document.referrer.indexOf("mixed-breed-puppy-height-calculator") !== -1) {
      $('.transient-intro').remove();
    }
  }
});
